import { Images, useDebouncedState } from '@urbanx/agx-ui-components';
import { useGetAllAgencies } from '@urbanx/agx.agencies.client';
import {
  AgxAvatar,
  AgxColumn,
  AgxRow,
  AgxTable,
  AgxTextInput,
  AgxTypography,
  IColumnConfig,
} from '@urbanx/agx.ui-components2';
import CleanPanel from 'components/cleanPanel/CleanPanel';
import LoadingState from 'components/loadingState/LoadingState';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

const preferencesCols: (string | IColumnConfig)[] = ['Partner'];

const PartnerPage = () => {
  const { data: agencies, isPending: isLoadingAgencies } = useGetAllAgencies();

  const [searchText, setSearchText] = useDebouncedState('', 300);

  const filteredAgencies = useMemo(() => {
    const lowerCaseSearch = searchText.toLowerCase();

    return (agencies ?? []).filter(
      (agency) => lowerCaseSearch === '' || agency?.name?.toLowerCase().includes(lowerCaseSearch)
    );
  }, [searchText, agencies]);

  const rows = useMemo(() => {
    return filteredAgencies.map((agency) => ({
      ['Partner']: (
        <AgxRow
          gap="spacing-lg"
          key={agency.id}
          justifyContent="left"
          fill
          alignItems="alignCenter"
        >
          {agency.logoUrl && <AgxAvatar type="image" size="sm" imageUri={agency.logoUrl} />}
          {!agency.logoUrl && (
            <AgxAvatar type="text-dark" size="sm" text={agency.name?.slice(0, 2) ?? ''} />
          )}
          <AgxTypography
            id={`partner-${agency.id}`}
            type="body"
            size="small"
            color="var(--text-primary)"
          >
            {agency.name}
          </AgxTypography>
        </AgxRow>
      ),
    }));
  }, [filteredAgencies]);

  if (isLoadingAgencies) {
    return <LoadingState />;
  }

  return (
    <CleanPanel>
      <AgxColumn gap={'spacing-2xl'} fill justifyContent="left" padding="spacing-2xl">
        <AgxTextInput
          id="partnerSearch"
          leftIcon={<Images.SearchOutline />}
          noHeader
          type="text"
          hideOptionalText
          placeholder="Search"
          stretch
          defaultValue={searchText}
          onChange={(value) => setSearchText(value)}
        />
        <AgxTable
          columns={preferencesCols}
          rows={rows}
          variant="default"
          renderRowLink={(index, linkProps) => {
            const agency = filteredAgencies[index];
            return agency.id ? (
              <Link
                {...linkProps}
                to={`./${agency.id}`}
                aria-label={agency.name?.trim() || `Agency ${agency.id}`}
              />
            ) : undefined;
          }}
        />
      </AgxColumn>
    </CleanPanel>
  );
};

export default PartnerPage;
